import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter, Link } from 'react-router-dom';
import Sticky from 'react-stickynode';

import BaseObjectField from '../BaseObjectField';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Tabs, { Tab } from 'material-ui/Tabs';
import CostEstimateForm from '../../../../../costEstimate/components/readonly/CostEstimateForm';
import { hasCostEstimate } from '../../../../../../utils/inspection-utils';
import { getCostEstimateForType } from '../../../../../costEstimate/costEstimate.selectors';
import * as actions from '../../../../../costEstimate/costEstimate.actions';

const styles = theme => ({
  tabs: {
    backgroundColor: theme.palette.common.white,
  },
  label: {
    fontSize: '10px !important',
    color: '#29694D !important',
  },
  badge: {
    backgroundColor: theme.palette.error['A400'],
    fontSize: 10,
    top: -theme.spacing.unit,
    right: -theme.spacing.unit * 2,
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
  },
  appBar: {
    borderLeft: '1px solid #fff',
    borderTop: '1px solid #fff',
    borderRight: '1px solid #fff',
    backgroundColor: '#fff',
  },
  footer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
});
class TabsComponent extends Component {
  state = {
    value: 'raportti',
  };
  componentDidMount = () => {
    const { readCostEstimates, id } = this.props;
    readCostEstimates(id);
  };
  componentWillReceiveProps = nextProps => {
    const { history } = this.props;
    const nextPropsTab = nextProps.match.params.tab;
    if (!nextPropsTab) {
      history.push(`/inspection/view/${nextProps.match.params.id}/raportti`);
      return;
    }
    if (nextPropsTab && this.state.value !== nextPropsTab) {
      this.setState({
        value: nextPropsTab,
      });
    }
  };

  onChangeTab = (event, value) => {
    this.setState({ value });
  };

  // deep check values too
  hasCostestimate = costEstimate => {
    return hasCostEstimate(costEstimate);
  };

  render() {
    const {
      classes,
      children,
      formContext,
      costEstimate,
      //orderedProperties,
      //schema,
    } = this.props;

    const hasCostestimate = this.hasCostestimate(costEstimate);
    const { value } = this.state;
    // if (!value) return null;

    return (
      <div>
        {value !== 'all' && (
          <Sticky>
            <AppBar position="static" elevation={0} className={classes.appBar}>
              <Tabs value={value} onChange={this.onChangeTab} fullWidth>
                <Tab
                  component={Link}
                  value={'raportti'}
                  to={`/inspection/view/${formContext._id}/raportti`}
                  //label={schema.properties[name].title}
                  label={'Raportti'}
                  classes={{
                    label: classes.label,
                  }}
                />

                {hasCostestimate && (
                  <Tab
                    component={Link}
                    value={'estimate'}
                    to={`/inspection/view/${formContext._id}/estimate`}
                    //label={schema.properties[name].title}
                    label={'Hinta-arvio'}
                    classes={{
                      label: classes.label,
                    }}
                  />
                )}
              </Tabs>
            </AppBar>
          </Sticky>
        )}
        {value === 'all' ? (
          <div>
            {children}
            {hasCostestimate && <CostEstimateForm />}
          </div>
        ) : value === 'estimate' ? (
          <CostEstimateForm />
        ) : (
          children
        )}
      </div>
    );
  }
}

TabsComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  formContext: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  options: PropTypes.array,
  orderedProperties: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

const mapStateToProps = (state, { match, backPath }) => {
  const { params: { id } } = match;
  const sellerCostEstimate = getCostEstimateForType(state, 'seller', id);
  const departmentCostEstimate = getCostEstimateForType(
    state,
    'department',
    id
  );
  return {
    backPath,
    id,
    costEstimate: { sellerCostEstimate, departmentCostEstimate },
  };
};

const enhance = compose(
  withProps({
    RootComponent: withRouter(
      connect(mapStateToProps, actions)(withStyles(styles)(TabsComponent))
    ),
  })
);

const TabsField = enhance(BaseObjectField);

export default TabsField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/readonly/TabsField.js